module.exports = {
	"ha": "viha",
	"id": 5.5,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category and MSM Status, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.29629629629629,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#043f61"
					},
					{
						"y": 92.5925925925926,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.18518518518519,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.37037037037037,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#09472e"
					},
					{
						"y": 48.148148148148145,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "60"
						},
						"color": "#043f61"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "50"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "49"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#09472e"
					},
					{
						"y": 56.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "54"
						},
						"color": "#043f61"
					},
					{
						"y": 92.5925925925926,
						"dataLabels": {
							"enabled": false,
							"format": "50"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.74074074074075,
						"dataLabels": {
							"enabled": false,
							"format": "49"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#09472e"
					},
					{
						"y": 55.55555555555556,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "259"
						},
						"color": "#043f61"
					},
					{
						"y": 95.36679536679536,
						"dataLabels": {
							"enabled": false,
							"format": "247"
						},
						"color": "#0c4250"
					},
					{
						"y": 92.66409266409266,
						"dataLabels": {
							"enabled": false,
							"format": "240"
						},
						"color": "#0d4440"
					},
					{
						"y": 86.10038610038609,
						"dataLabels": {
							"enabled": false,
							"format": "223"
						},
						"color": "#09472e"
					},
					{
						"y": 65.25096525096525,
						"dataLabels": {
							"enabled": false,
							"format": "169"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#043f61"
					},
					{
						"y": 91.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#09472e"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#043f61"
					},
					{
						"y": 79.3103448275862,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0c4250"
					},
					{
						"y": 72.41379310344827,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0d4440"
					},
					{
						"y": 58.620689655172406,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#09472e"
					},
					{
						"y": 31.03448275862069,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "74"
						},
						"color": "#043f61"
					},
					{
						"y": 94.5945945945946,
						"dataLabels": {
							"enabled": false,
							"format": "70"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.8918918918919,
						"dataLabels": {
							"enabled": false,
							"format": "68"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.37837837837837,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#09472e"
					},
					{
						"y": 44.5945945945946,
						"dataLabels": {
							"enabled": false,
							"format": "33"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "228"
						},
						"color": "#043f61"
					},
					{
						"y": 93.42105263157895,
						"dataLabels": {
							"enabled": false,
							"format": "213"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.59649122807018,
						"dataLabels": {
							"enabled": false,
							"format": "202"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "190"
						},
						"color": "#09472e"
					},
					{
						"y": 53.50877192982456,
						"dataLabels": {
							"enabled": false,
							"format": "122"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 70,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#043f61"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0c4250"
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#0d4440"
					},
					{
						"y": 45,
						"dataLabels": {
							"enabled": false,
							"format": "9"
						},
						"color": "#09472e"
					},
					{
						"y": 25,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#043f61"
					},
					{
						"y": 73.52941176470588,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.58823529411765,
						"dataLabels": {
							"enabled": false,
							"format": "24"
						},
						"color": "#0d4440"
					},
					{
						"y": 58.82352941176471,
						"dataLabels": {
							"enabled": false,
							"format": "20"
						},
						"color": "#09472e"
					},
					{
						"y": 41.17647058823529,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#043f61"
					},
					{
						"y": 86.11111111111111,
						"dataLabels": {
							"enabled": false,
							"format": "62"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.55555555555556,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "54"
						},
						"color": "#09472e"
					},
					{
						"y": 52.77777777777778,
						"dataLabels": {
							"enabled": false,
							"format": "38"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.12734082397003,
						"dataLabels": {
							"enabled": false,
							"format": "262"
						},
						"color": "#043f61"
					},
					{
						"y": 85.76779026217228,
						"dataLabels": {
							"enabled": false,
							"format": "229"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.14606741573034,
						"dataLabels": {
							"enabled": false,
							"format": "222"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.14981273408239,
						"dataLabels": {
							"enabled": false,
							"format": "214"
						},
						"color": "#09472e"
					},
					{
						"y": 56.17977528089888,
						"dataLabels": {
							"enabled": false,
							"format": "150"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.703703703703709,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.9999999999999964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.391304347826086,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.57894736842105,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.0000000000000018,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.163265306122447,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.444444444444446,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.4074074074074066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.0000000000000018,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.163265306122447,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.633204633204635,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.8340080971659964,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.08333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.215246636771305,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.68965517241379,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.047619047619047,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -47.05882352941176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.405405405405405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.857142857142858,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.70588235294118,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -43.103448275862064,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.578947368421051,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.164319248826288,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.940594059405946,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.78947368421053,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.999999999999998,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.44444444444444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.000000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.888888888888884,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.896551724137934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.629629629629626,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.8726591760299671,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.595419847328248,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.056768558951961,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.6036036036036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.90654205607477,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=27"
			},
			{
				"x": 9,
				"text": "30-39<br>n=60"
			},
			{
				"x": 15,
				"text": "40-49<br>n=54"
			},
			{
				"x": 21,
				"text": ">=50<br>n=259"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=12"
			},
			{
				"x": 34,
				"text": "30-39<br>n=29"
			},
			{
				"x": 40,
				"text": "40-49<br>n=74"
			},
			{
				"x": 46,
				"text": ">=50<br>n=228"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=20"
			},
			{
				"x": 59,
				"text": "30-39<br>n=34"
			},
			{
				"x": 65,
				"text": "40-49<br>n=72"
			},
			{
				"x": 71,
				"text": ">=50<br>n=267"
			}
		],
		"dataTable": {
			"MSM:<30": [
				27,
				26,
				25,
				23,
				19,
				13
			],
			"MSM:30-39": [
				60,
				60,
				50,
				49,
				45,
				34
			],
			"MSM:40-49": [
				54,
				54,
				50,
				49,
				45,
				30
			],
			"MSM:>=50": [
				259,
				259,
				247,
				240,
				223,
				169
			],
			"Non-MSM:<30": [
				12,
				12,
				11,
				11,
				9,
				6
			],
			"Non-MSM:30-39": [
				29,
				29,
				23,
				21,
				17,
				9
			],
			"Non-MSM:40-49": [
				74,
				74,
				70,
				68,
				58,
				33
			],
			"Non-MSM:>=50": [
				228,
				228,
				213,
				202,
				190,
				122
			],
			"Unknown:<30": [
				20,
				14,
				10,
				10,
				9,
				5
			],
			"Unknown:30-39": [
				34,
				32,
				25,
				24,
				20,
				14
			],
			"Unknown:40-49": [
				72,
				72,
				62,
				58,
				54,
				38
			],
			"Unknown:>=50": [
				267,
				262,
				229,
				222,
				214,
				150
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_5.json
// module id = 340
// module chunks = 0